(ns hai.ui.components.collection.core
  "Core functionality of all collection components such as data tables"
  (:require
   [hai.ui.components.collection.bulk-actions :as bulk-actions]
   hai.ui.components.collection.query
   [hai.ui.components.collection.utils :as utils]
   [hai.ui.rf-sugar :refer [defevent defevent-fx defsub]]
   [hai.ui.utils.validate :refer [validate]]
   [medley.core :refer [deep-merge]]))

(def CollectionType
  ;; TODO rename `:rows` to `:collection/items`
  [:enum :rows :rows-sub :query])

(def Collection
  [:map
   [:collection/type CollectionType]
   [:collection/app-db-schema :any]
   ;; Custom filter-row renderer (a component `[table]`) that fully replaces the
   ;; built-in filter row — e.g. `filters/pill-bar`. Declared here so it survives
   ;; `strip-extra-keys` during `decode-table-props`; otherwise the view never
   ;; sees it and falls back to the built-in row.
   [:filters/render {:optional true} :any]
   ;; Where the table view mounts the filter UI: `:table-header` (default)
   ;; renders it inside the table's header, `:sibling` renders it as a sibling
   ;; of the table root — like the cards view does — for collections whose
   ;; filter UI is page chrome (e.g. a sidebar) rather than a header row.
   [:filters/placement {:optional true} [:enum :table-header :sibling]]
   ;; When false, the collection's built-in text-search box is hidden.
   [:collection/searchable? {:optional true} :boolean]])

(defevent-fx ::setup
  [{:keys [db]}
   {:table/keys [id rows]
    :collection.query/keys [error]
    :as table-data}]
  (let [table (-> (get-in db [:collections id])
                  (deep-merge table-data))
        table (cond-> table
                (not error) (dissoc :collection.query/error))
        ;; TODO this is actions specific
        table (assoc table :table/selected (or (:table/selected table) bulk-actions/default))
        {:form/keys [current-value] :as form-initiated?} (get-in db [:forms id])]
    (validate (:collection/app-db-schema table) table)
    (cond-> {:db (assoc-in db [:collections id] table)}
      form-initiated? (assoc :fx [[:dispatch [:form/re-init id (assoc current-value :table/rows rows)]]]))))

(defn db-tables
  [db]
  (get db :collections))

(defsub :tables
  [db]
  (db-tables db))

(defn table-from-db
  [db ?table]
  (utils/->table db ?table))

(defn rows-from-db
  [db ?table]
  (let [table (utils/->table db ?table)]
    (get table :table/rows)))

(defsub :table
  ;; NOTE (evgheni): Yes, we can get the table directly from DB.
  ;;                 But this way we only re-calculate the table value if :tables slice is updated.
  ;;                 If we subscribe to the whole db, the table will be recalculated on _any_ change in the app-db.
  ;;
  ;;                 BTW, this is an example of how to make re-frame a bit faster. Remember to subscribe to specific slices.
  [?table
   tables <- :tables]
  (get tables
       (utils/->id ?table)))

(defsub :table/rows
  [?table
   table <- [:table ?table]]
  (get table :table/rows))

(defsub :table/columns
  [?table
   table <- [:table ?table]]
  (get table :table/columns))

(defsub :table/resolving?
  [?table
   table <- [:table ?table]]
  (get table :table/resolving?))

(defevent :table/assoc
  [db ?id attr value]
  (assoc-in db [:collections (utils/->id ?id) attr] value))
